/** 메인박스 도메인  */
export function loginDomain(){
	var domain = "";
	var box = "www.ibkbox.net";
	if(window.location.href.indexOf("//local") > -1){
		domain = "http://local"+box+":8081";
	}else if(window.location.href.indexOf("//dev") > -1){
		domain = "https://dev"+box;
	}else{
		domain = "https://"+box;
	}
	return domain;
}

/** 대출통로박스 도메인  */
export function lrDomain(){
	var domain = "";
	if(window.location.href.indexOf("82") > -1){
		domain = "82";
	}else if(window.location.href.indexOf("365") > -1){
		domain = "365";
	}
	return domain;
}

/** 인증센터 도메인  */
export function certDomain(){
	var domain = "";
	var cert = "cert.ibkbox.net";
	if(window.location.href.indexOf("//local") > -1){
		domain = "https://dev"+cert;
	}else if(window.location.href.indexOf("//dev") > -1){
		domain = "https://dev"+cert;
	}else{
		domain = "https://"+cert;
	}
	return domain;
}

/** 개발/운영 구분  */
export function domainType(type){
	var domain = "";
	if(window.location.href.indexOf("//local") > -1){
		domain = "https://dev"+type+".ibkbox.net";
	}else if(window.location.href.indexOf("//dev") > -1){
		domain = "https://dev"+type+".ibkbox.net";
	}else{
		domain = "https://"+type+".ibkbox.net";
	}
	return domain;
}

/**로컬 체크 */
export function localChk(){
	if(window.location.href.indexOf("//local") > -1){
		return true;
	}
	return false;
}

/** PC, Mobile 구분 */
export function osType(){
	var mobile = (/iphone|ipad|ipod|android/i.test(navigator.userAgent.toLowerCase()));
	var chkOs;
	if(mobile){
		chkOs = "mobile";
	}else{
		chkOs = "pc";
	}
	return chkOs;
}

/** OS 구분 */
export function chkOsType(){
	var mobile = (/iphone|ipad|ipod|android/i.test(navigator.userAgent.toLowerCase()));
	var mobileOs = navigator.userAgent.toLowerCase();
	var chkOs;
	if(mobile){
		if(mobileOs.indexOf('android') > -1){
			chkOs="mobile-android";
		}else if(mobileOs.indexOf('iphone') > -1){
			chkOs="mobile-iphone";
		}else{
			chkOs="mobile-ipad";
		}
	}else{
		if(mobileOs.indexOf('windows') > -1){
			chkOs="pc-windows";
		}else{
			chkOs="pc-mac"
		}

	}
	return chkOs;
}

/** OS 상세 구분 */
export function osDetail(){
	var mobileOs = navigator.userAgent.toLowerCase();
	var chkOs;
	var startIndex = mobileOs.indexOf('(');
	var endIndex = mobileOs.indexOf(')');
	chkOs = mobileOs.substring(startIndex+1,endIndex);
	return chkOs;
}

/* Email 체커*/
export function rightEmail(str){
	let tmpStr = str;
	let regEmail = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]/;
	return regEmail.test(tmpStr);
}

/** '-' 제거 */
export function removeS(str){
	let reStr = str.replace(/\-/g,"");
	return reStr;
}

/**전화번호 유효성 체크 */
export function isTelFormat(tel){
	var phoneRule = /^(070|02|0[3-9]{1}[0-9]{1}|01[016789]{1})[0-9]{3,4}[0-9]{4}$/;
	return phoneRule.test(tel);
}

/* 금액에 콤마 추가*/
export function comma(str){
	str = String(str);
	str = str.replace(/[^\d]+/g,'');
	return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g,'$1,')
}

export function uncomma(str){
	str = String(str);
	return str.replace(/[^\d]+/g,'');
}

/**
 * 날짜 포맷
 * @param {Date} date
 * @param {String} delimeter
 * @returns {String} YYYY.MM.DD
 */
export function dateFormat(date, delimeter = "."){
	const leftPad = (value) =>{
		if(value >= 10){
			return value;
		}

		return `0${value}`
	}

	const year = date.getFullYear();
	const month = leftPad(date.getMonth()+1);
	const day = leftPad(date.getDate());

	return [year, month, day].join(delimeter);
}

/** 날짜 문자열 타입 */
export function stDateForm(date){
	return date.substr(0,4)+'.'+date.substr(4,2)+'.'+date.substr(6);
}

/** 날짜 문자열 '-' 타입 */
export function hypenDateForm(date){
	return date.substr(0,4)+'-'+date.substr(4,2)+'-'+date.substr(6);
}

/* 사업자번호 자동 - 하이픈 */
export function autoHypenBiz(num){
	num = num.replace(/[^0-9]/g, '');
	return num.replace(/^(\d{2,3})(\d{1,2})(\d{5})/,`$1-$2-$3`);
}

/* 핸드폰번호 자동 - 하이픈 */
export function autoHypenPhone(num){
	num = num.replace(/[^0-9]/g, '')
	if(num.length === 11){
		return num.replace(/^(\d{2,3})(\d{3,4})(\d{4})/,`$1-$2-$3`);
	}else{
		return num.replace(/^(\d{1,2})(\d{2,4})(\d{4})/,`$1-$2-$3`);
	}
	
}

/*
* 널체크
*/
export function nullCheck(x){
	if(x==null || x=="null") return false;
	
	if(typeof x === 'number'){
		if(x == 0){
			return false;
		}else {
			return true;
		}
		
	}else if(typeof x === 'string'){
		if(x.trim() == ""){
			return false;
		}else {
			return true;
		}
	}
}

export function doLpad(psVal, pnWidth) {
	psVal = psVal + '';
	
	return psVal.length >= pnWidth ? psVal : 0 + psVal;
}

export function tokenStringCheck(e) {
	return null != e && "null" != e && "undefined" != e && "" != e.trim() ;
}

/*금액 한글+숫자표시*/
export function num2han(num){
	if( typeof num !== "string"){
		num = String(num)
	}
	var hanA = new Array('','1','2','3','4','5','6','7','8','9','10');
	var danA = new Array('','십','백','천','','십','백','천','','십','백','천','','십','백','천');
	num=num.replace(/[^\d]+/g,'');
	var result = "";
	for(var i=0; i<num.length; i++){
		var str = "";
		var han = hanA[num.charAt(num.length-(i+1))];
		if(han != "") str += han+danA[i];
		if(i==4) str += "만";
		if(i==8) str += "억";
		if(i==12) str += "조";
		result = str + result;
	}
	if(result[result.indexOf("만")-1] == "억"){
		result = result.replace('만','');
	}
	if(num != 0) result = result;
	
	return result ;
}

/*금액 한글표시*/
export function numTohan(num){
	if( typeof num !== "string"){
		num = String(num)
	}
	var hanA = new Array('','일','이','삼','사','오','육','칠','팔','구','십');
	var danA = new Array('','십','백','천','','십','백','천','','십','백','천','','십','백','천');
	num=num.replace(/[^\d]+/g,'');
	var result = "";
	for(var i=0; i<num.length; i++){
		var str = "";
		var han = hanA[num.charAt(num.length-(i+1))];
		if(han != "") str += han+danA[i];
		if(i==4) str += "만";
		if(i==8) str += "억";
		if(i==12) str += "조";
		result = str + result;
	}
	if(result[result.indexOf("만")-1] == "억"){
		result = result.replace('만','');
	}
	if(num != 0) result = result +"원";
	
	return result ;
}

export function unitTohan(num){
	if( typeof num !== "number"){
		num = Number(num)
	}
	var inputnum = num < 0 ? false : num;
	var unitWords = ['','만','억','조','경'];
	var splitUnit = 10000;
	var splitCount = unitWords.length;
	var resultArray = [];
	var resultString = '';

	for(var i=0; i<splitCount; i++){
		var unitResult = (inputnum % Math.pow(splitUnit, i+1)) / Math.pow(splitUnit,i);
		unitResult = Math.floor(unitResult);
		if(unitResult > 0){
			resultArray[i] = unitResult;
		}
	}
	for(var j=0; j<resultArray.length; j++){
		if(!resultArray[j]) continue;
		resultString = String(numFormat(resultArray[j])) + unitWords[j] + resultString
	}
	return resultString;
}
function numFormat(x){
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g,",")
}
/** 오늘 날짜 문자열로 구하기 */
export function getTodayDate(){
	let today = new Date();
	let year = today.getFullYear();
	let month = ('0' + (today.getMonth() + 1)).slice(-2);
	let day = ('0' + today.getDate()).slice(-2);
	return year+"-"+month+"-"+day;
}

/** 오늘 날짜 문자열로 구하기 */
export function getTodayDate2(){
	let today = new Date();
	let year = today.getFullYear();
	let month = ('0' + (today.getMonth() + 1)).slice(-2);
	let day = ('0' + today.getDate()).slice(-2);
	return year+"."+month+"."+day;
}

export function saveNow(){
	let now = new Date();
    sessionStorage.setItem('sendTime',JSON.stringify(now.getTime()));
}

/* 계좌번호 자동 - 하이픈 */
export function autoHypenAc(num){
	num = num.replace(/[^0-9]/g, '')
	return num.replace(/^(\d{2,3})(\d{6})(\d{2})(\d{3})/,`$1-$2-$3-$4`);
	
}

export const getEncode = (str) => {
	let encodeValue = encodeURIComponent(str)
	   .replace(/\-/g, "%2D")
	   .replace(/\_/g, "%5F")
	   .replace(/\./g, "%2E")
	   .replace(/\!/g, "%21")
	   .replace(/\~/g, "%7E")
	   .replace(/\*/g, "%2A")
	   .replace(/\'/g, "%27")
	   .replace(/\(/g, "%28")
	   .replace(/\)/g, "%29");
	 return encodeValue;
}

/** 법인/개인 구분 */
export const chkBizType = (biznum) =>{
	const biznum2 = biznum.slice(3, 5);
	if (Number(biznum2) >= 81 && Number(biznum2) <= 88) {
		return 'corporate';
	}else{
		return 'individual';
	}
}


/** 날짜 문자열 처리 */
export const timeChk = (time) => {
	//101535 => 10:15
	return time.substr(0,2)+':'+time.substr(2,2);
}


/*
 * 쿠키에 저장된 정보를 반환한다.
 */
export const cookieValue=(c_name) => {
    var name = c_name + "=";
    var arr = document.cookie.split(";");
    for (var i=0; i<arr.length; i++) {
        var c = arr[i];
        while (c.charAt(0) == ' ' ) {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length , c.length);
        }
    }
    return "";
}